export default "__VITE_ASSET__2yZOZtdU__"